import React from 'react';
import DECLINED_ICON from '@arrive/ui-icons/svg/ic_decline.svg'

import LandingPage from '../../LandingPage/LandingPage';

import DeclinedTenderStyles from './DeclinedTender.scss';
import { useCommittedCapacityContext } from 'components/CommittedCapacity/context/committed-capacity.context';

export default function DeclinedTender() {
  const { tenderDetails } = useCommittedCapacityContext();

  return (
    <LandingPage
      actionLinkTo="/find-loads"
      className={DeclinedTenderStyles.declinedTenderContainer}
      actionText="Looking for loads? Search our Load Board"
      content={
        <>
          <span>Thank you for participating in the Committed Capacity Program.</span>
          <br />
          <span>Contact your rep if you have any questions or changes.</span>
        </>
      }
      icon={DECLINED_ICON}
      subTitle={`Load tender #${tenderDetails.loadNumber} was declined.`}
    />
  );
}
